module.exports = __webpack_public_path__ + "static/media/question.7c3a91b7.svg";